export default __webpack_public_path__ + "static/media/Girdle of the Valiant.64af1c97.jpg";